__webpack_require__.p = "/web-portal/";